import { CircularProgress, } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import {
    useGoogleReCaptcha
} from 'react-google-recaptcha-v3';
import { FormattedMessage } from "react-intl";
import { Link, useNavigate } from "react-router-dom";
import { Button, Col, Label, NavLink, Row } from "reactstrap";
import InputComponent from "../../components/InputComponent";
import { useAuth } from "../../context/AuthContext";
import { useAvailableModulesContext } from "../../context/AvailableModulesContext";
import Toast from "../../helpers/Toast";
import { Utilities } from "../../helpers/Utilities";
import { LoginDTO, LoginDTOSchema } from "../../models/LoginDTO";
import { AuthService } from "../../services/AuthService";
import "../../styles/auth.css";
import Banner from './Banner';
import { useMobile } from '../../components/Layout/UseResponsive';

export default function Login() {
    const { setCurrentUser, isUserLoggedIn } = useAuth();
    const service: AuthService = new AuthService();
    const navigate = useNavigate();
    const isMobile = useMobile();

    const [Email, setStateEmail] = useState("");
    const [Password, setStatePassword] = useState("");
    const [Resultlogin, setStateResultLogin] = useState("");
    const [Loading, setStateLoading] = useState<boolean>(false);
    const { executeRecaptcha } = useGoogleReCaptcha();

    const { availableModules, reactAppName } = useAvailableModulesContext();
    const [isActiveMaintenanceModule, setIsActiveMaintenanceModule] = useState<boolean>(false);
    const [showMaintenancePlanAfterLogin, setShowMaintenancePlanAfterLogin] = useState<boolean>(false);
    const [isRecaptchaActive, setIsRecaptchaActive] = useState<boolean>(true);

    const handleReCaptchaVerify = useCallback(async () => {
        if (!executeRecaptcha) {
            return;
        }

        await executeRecaptcha('homepage');

        // Do whatever you want with the token
    }, [executeRecaptcha]);

    const onClickLoginButton = async () => {
        let token = "";

        // Only get reCAPTCHA token if reCAPTCHA is active
        if (isRecaptchaActive && executeRecaptcha) {
            token = await executeRecaptcha('homepage');
        }

        var auth: LoginDTO = {
            email: Email,
            password: Password,
            recaptchaToken: token,
        };

        var responseValidate = await LoginDTOSchema.validate(auth);
        if (responseValidate.error != null) {
            var message = responseValidate.error!.details[0].message;
            Toast.Show("error", message);
            return;
        }

        setStateLoading(true);
        var response = await service.Login(auth);

        if (response.success === true && response.obj != null) {
            setCurrentUser(response.obj);

            Toast.Show("success", "Login efetuado com sucesso!");

            setStateLoading(false);

            var route = Utilities.MapViewToRoute(response.obj!.preferedView, isActiveMaintenanceModule, showMaintenancePlanAfterLogin);
            //Mudar a vista
            navigate(route);

        } else {
            setStateResultLogin(response.message);
            setStateLoading(false);
        }
    };

    useEffect(() => {
        if (isUserLoggedIn) {
            navigate('/');
        }
    }, [isUserLoggedIn]);

    useEffect(() => {
        if (availableModules.includes("IsActiveMaintenanceModule")) {
            setIsActiveMaintenanceModule(true);
        }
        if (availableModules.includes("ShowMaintenancePlanAfterLogin")) {
            setShowMaintenancePlanAfterLogin(true);
        }
        // Check if reCAPTCHA module is active (default to true if not found)
        setIsRecaptchaActive(availableModules.includes("IsActiveRecaptchaModule"));

    }, [availableModules]);

    // You can use useEffect to trigger the verification as soon as the component being loaded
    useEffect(() => {
        if (isRecaptchaActive) {
            handleReCaptchaVerify();
        }
    }, [handleReCaptchaVerify, isRecaptchaActive]);

    return (
        <Row className="auth-page" style={{ display: "flex", height: "100%", margin: "0px", padding: "0px" }}>
            {/* Image on left */}
            <Banner />

            {/* Right*/}
            <Col
                lg={6}
                style={{
                    display: "flex",
                    alignItems: "center",
                    alignContent: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                }}
            >
                <Row style={{ marginBottom: "20px" }}>
                    <Col md={12} className="siteName">
                        <Label>{reactAppName}</Label>
                    </Col>
                </Row>

                <Row style={{ marginBottom: "20px" }}>
                    <Col md={12} className="siteWelcome">
                        <Label>
                            <FormattedMessage id="Screens.Auth.SubTitle.Login" />
                        </Label>
                    </Col>
                </Row>

                {/* Input email*/}
                <Row style={{ margin: "0px 0px 35px 0px", padding: "0px", minWidth: "50%", width: isMobile ? "100%" : "inherit" }}>
                    <InputComponent
                        xl={12}
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        style={{ textAlign: "center", width: "100%" }}
                        type={"text"}
                        value={Email}
                        label={"Email"}

                        readOnly={false}
                        onChange={(text: string) => setStateEmail(text)}
                        data-testid="input-email"
                    />
                </Row>

                {/* Input password*/}
                <Row style={{ margin: "0px 0px 10px 0px", padding: "0px", minWidth: "50%", width: isMobile ? "100%" : "inherit" }} >
                    <InputComponent
                        xl={12}
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        style={{ textAlign: "center", width: "100%" }}
                        type={"password"}
                        value={Password}
                        label={"Password"}
                        readOnly={false}
                        onChange={(text: string) => setStatePassword(text)}
                        data-testid="input-password"
                    />
                </Row>

                <Row>
                    <Col md={12}>
                        <label style={{ color: "red" }}>{Resultlogin}</label>
                    </Col>
                </Row>

                <Row style={{ margin: "0px 0px 50px 0px", padding: "0px", minWidth: "50%" }}>
                    <Col md={12} sm={12} xs={12} lg={12} style={{ textAlign: "center" }}>
                        <Row
                            className="loginbuttons"
                            style={{ margin: "0px", padding: "0px", minWidth: "50%" }}
                        >
                            {Loading === true ? (
                                <Col md={12} sm={12} xs={12} lg={12} style={{ textAlign: "center" }}>
                                    <CircularProgress
                                        style={{ marginLeft: "10px" }}
                                        size={"25px"}
                                    />
                                </Col>
                            ) : (
                                <Col md={12} sm={12} xs={12} lg={12} style={{ textAlign: "center" }}>
                                    <Button
                                        disabled={isRecaptchaActive && !handleReCaptchaVerify}
                                        className="enteraccount"
                                        onClick={onClickLoginButton}
                                    >
                                        <FormattedMessage id="Screens.Auth.Button.Login" />
                                    </Button>
                                </Col>
                            )}
                        </Row>
                    </Col>
                </Row>
                <Row
                    className="extratext"
                    style={{ margin: "10px 0px 40px 0px", padding: "0px", minWidth: "50%" }}
                >
                    <Col
                        md={12}
                        sm={12}
                        xs={12}
                        lg={12}
                        style={{ textAlign: "center", margin: "auto" }}
                    >
                        <NavLink
                            tag={Link}
                            className="forgotPasswordLink"
                            to={{ pathname: `/ForgotPassword` }}
                        >
                            <FormattedMessage id="Screens.Auth.Button.ForgotPasswordLink" />
                        </NavLink>
                    </Col>
                </Row>
            </Col>
        </Row>
    );
}
